export const CONSTANTS  = {
    'AUTHOR': 'Nguyen Duc Dung',
    'AUTHOR_GITHUB_LINK': 'https://github.com/dungng1321',
}